export const EQUIPMENTS = 'EQUIPMENTS';
export const EQUIPMENT_COUNT = 'EQUIPMENT_COUNT';
